import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AbstractCsvExportService } from '../common/file/abstract-csv-export.service';
import { FileSaverService } from '../common/file/file-saver.service';
import { FileSaverUsecase } from '../../domain/model/file-saver-usecase.enum';
import { NetzbetreiberTeilgebieteInfo } from '../auth/netzbetreiber-teilgebiete-info';


@Injectable({
    providedIn: 'root',
})
export class ErzeugungsanlageExportService extends AbstractCsvExportService {
    protected http: HttpClient;
    protected fileSaverService: FileSaverService;

    constructor() {
        const http = inject(HttpClient);
        const fileSaverService = inject(FileSaverService);

        super(http, fileSaverService);

        this.http = http;
        this.fileSaverService = fileSaverService;
    }

    public exportErzeugungsanlagen(
        stadtwerkeId?: string,
        teilgebiet?: string,
    ) {
        let params = new HttpParams();

        if (stadtwerkeId) {
            params = params.set('stadtwerkeId', stadtwerkeId);
        }

        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
            params: params,
        };

        this.http.get(environment.API_URL + '/erzeugungsanlage/erzeugungsanlagen.xlsx', {
            ...httpOptions,
            responseType: 'blob',
        }).subscribe(res => {
            this.fileSaverService.saveFileByUsecaseAsNvnb(
                FileSaverUsecase.EXCEL_EXPORT_ERZEUGUNGSANLAGEN,
                res,
                teilgebiet,
            );
        });
    }

    public exportErzeugungsanlagenCSV(teilgebiet?: NetzbetreiberTeilgebieteInfo) {
        this.exportCsv(
            '/erzeugungsanlage/erzeugungsanlagen.csv',
            FileSaverUsecase.CSV_EXPORT_ERZEUGUNGSANLAGEN,
            teilgebiet,
        );
    }
}



